import Colors from '@constants/Colors';
import { Stack, Typography } from '@mui/material';


type Props = {
    title?: string;
    breadcrumbs?: string[];
    description?: string;
    titleWidth?: number;
    textAlignment?: 'center' | 'left' | 'right';
};

const FormHeader = (props: Props) => {
    return (
        <Stack
            sx={{
                marginBottom: {
                    md: 4,
                    xs: 0,
                },
                marginTop: 1,
                gap: {
                    xs: 2,
                    sm: 1
                }
            }}>
            <Typography
                style={{ textAlign: props.textAlignment || 'center', width: props?.titleWidth }}
                color={Colors.NEUTRAL_BLACK}
                fontFamily={"Lemon milk pro"}
                fontWeight={700}
                fontSize={
                    {
                        xs: 20,
                        sm: 24,
                        md: 28,
                        lg: 32,
                    }
                }>
                {props.title}
            </Typography>
            {props.description && (
                <Typography style={{ textAlign: props.textAlignment || 'center' }}
                    fontSize={
                        {
                            xs: 14,
                            sm: 16,
                            md: 18,
                        }

                    }
                    color={Colors.PRIMARY_PURPLE}
                >
                    {props.description}
                </Typography>
            )}
        </Stack>
    );
};


export default FormHeader;
